import { MoreSvgIcon } from './svg';
import { makeIcon } from './make-icon';

export const MoreIcon = makeIcon(MoreSvgIcon, 'MoreIcon')`
  position: relative;
  top: 0.155em;

  path {
    fill: currentColor;
  }
`;
